/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { observer } from 'mobx-react-lite'
import { useMobxStore } from '../../../state'
import colors from '@sportninja/common/constants/appColors'
import pageIcon from './confirm_profile_exclamation.svg'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { EventDetails } from './Login'
import dayjs from 'dayjs'

export const EventCard = ({ eventInfo }) => (
  <div
    css={css`
      background-color: ${colors.LINK_WATER};
      padding: 16px;
      border-radius: 8px;
      margin-top: 32px;
    `}
  >
    <p>COMPETITION INFO</p>
    <p
      css={css`
        margin: 8px 0;
        font-size: 32px;
        font-weight: 700;
        font-family: ${isCanlan
          ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
          : 'Rift, Arial, Helvetica, sans-serif'};
      `}
    >
      {eventInfo?.name}
    </p>
    <EventDetails label='Organization' value={eventInfo?.registration?.organization_name} />
    <EventDetails
      label='Dates'
      value={`${dayjs(eventInfo?.registration?.starts_at).format('MMM D')} - ${dayjs(
        eventInfo?.registration?.ends_at
      ).format('MMM D, YYYY')} `}
    />
    {eventInfo?.registration?.location && (
      <EventDetails label='Location' value={eventInfo?.location} />
    )}
  </div>
)

export const ConfirmProfile = observer(() => {
  const {
    registrationInvite: {
      state: { eventInfo },
      confirmTeamRepStep,
      confirmPlayerStep,
    },
  } = useMobxStore()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
      `}
    >
      <img
        src={pageIcon}
        css={css`
          width: 234px;
          height: 152px;
          align-self: center;
        `}
      />
      <h1
        css={css`
          text-align: center;
          margin-top: 32px;
          font-size: 30px;
          font-weight: 700;
          font-family: ${isCanlan
            ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
            : 'Rift, Arial, Helvetica, sans-serif'};
        `}
      >
        Do you want to register yourself or a team for:
      </h1>
      <EventCard eventInfo={eventInfo} />
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 32px;
        `}
      >
        <button
          onClick={() => confirmTeamRepStep({ scheduleId: eventInfo?.id })}
          css={css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 0;
            margin-right: 8px;
            flex: 1;
            height: 40px;
            border: 2px solid #3f4753;
            border-radius: 4px;
            font-size: 18px;
            font-weight: 700;
            font-family: ${isCanlan
              ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
              : 'Rift, Arial, Helvetica, sans-serif'};
          `}
        >
          I’M THE TEAM REPRESENTATIVE
        </button>
        <button
          onClick={() => confirmPlayerStep({ scheduleId: eventInfo?.id })}
          css={css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 8px 0;
            margin-left: 8px;
            color: white;
            flex: 1;
            height: 40px;
            background: ${colors.DEFAULT_FLAIR};
            border-radius: 4px;
            font-size: 18px;
            font-weight: 700;
            font-family: ${isCanlan
              ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif;'
              : 'Rift, Arial, Helvetica, sans-serif'};
          `}
        >
          I’M A PLAYER
        </button>
      </div>
    </div>
  )
})
